// extracted by mini-css-extract-plugin
export default {"db-grid":"DashboardScreen_db-grid__OL8Sm","grid-1":"DashboardScreen_grid-1__IKfZt","grid-2":"DashboardScreen_grid-2__t0zTJ"};